import React, { useEffect } from 'react';
import './MaintenancePage.css';

const MaintenancePage = ({ title, content }) => {
  useEffect(() => {
    document.title = title || '系統維護中';
  }, [title]);

  return (
    <div className="maintenance-container">
      <div className="maintenance-content">
        <div className="maintenance-header">
          <h2>{title || '系統維護中'}</h2>
        </div>
        <div className="maintenance-body">
          <div className="maintenance-animation">
            <div className="maintenance-icon">
              <i className="bi bi-tools"></i>
            </div>
          </div>
          <div className="maintenance-message">
            {content || '系統正在進行維護，請稍後再試。'}
          </div>
          <div className="maintenance-info">
            <p>我們正在努力提升服務品質，造成不便敬請見諒。</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
